import { END_APPOINTMENT } from './constants';

import fetchWithRefresh from './fetchWithRefresh';

export interface EndVisitResponse {
    success?: boolean;
}

export default ({
    visitId,
    startDateTime,
    endDateTime,
    ptOid,
    docId,
    clinicId,
    status,
}: {
    visitId: string;
    startDateTime?: string;
    endDateTime?: string;
    ptOid: string;
    docId: string;
    clinicId: string;
    status: 'AB' | 'PA' | 'CMNP';
}): Promise<EndVisitResponse> => {
    const params = {
        status,
        // prescription_id: id,
        // follow_up: date,
        doctor: {
            oid: docId,
            clinic: clinicId,
        },
        pid: {
            oid: ptOid,
        },
        visit: {
            st: startDateTime,
            et: endDateTime,
            localid: visitId,
        },
    };
    return fetchWithRefresh(END_APPOINTMENT(visitId), {
        method: 'PUT',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw Error('failed end-visit');
        }
    });
};
